import React, { useEffect } from "react";
import _ from 'underscore';
import moment from 'moment';
import { Form, Input, Button, Table, message, DatePicker, Checkbox, Select } from 'antd';
import filter from './utils/filter.js';

const { Option } = Select;

const datePickerFormat = 'MMM Do YYYY';
const by = 'resource';

const ApprovalFindByResourceForm = ({ resources, selectedResource, requestDates, ...props }) => {

  const { getFieldDecorator, getFieldsError, getFieldsValue } = props.form;

  useEffect(() => { // set form values
    const form = props.form;
    form.setFieldsValue({
      selectedResource: selectedResource.name ? selectedResource.name : '',
      fromDate: requestDates.fromDate ? moment(requestDates.fromDate).startOf('day') : moment().startOf('day'),
      toDate: requestDates.toDate ? moment(requestDates.toDate).startOf('day') : moment().startOf('day'),
    });
  }, [requestDates, resources, selectedResource]);

  const invalidForm = () => {
    message.config({
      top: 150,
      duration: 5,
      maxCount: 5,
    });
    message.error('You have one or more invalid form inputs!');
  };

  const validateForm = () => { // validates the whole form
    const form = props.form;

    const fromDate = form.getFieldValue('fromDate') ? form.getFieldValue('fromDate').startOf('day').clone() : null;
    const toDate = form.getFieldValue('toDate') ? form.getFieldValue('toDate').startOf('day').clone() : null;
    const selectedResource = form.getFieldValue('selectedResource');

    let fromDateErrors = [];
    if (!fromDate) {
      fromDateErrors.push(new Error('Please input start date!'));
    }
    if (fromDate && toDate && toDate.isBefore(fromDate)) {
      fromDateErrors.push(new Error('Start date cannot occur after end date!'));
    }
    if (fromDateErrors.length > 0) {
      form.setFields({
        fromDate: {
          value: fromDate,
          errors: fromDateErrors,
        }
      });
    } else {
      form.setFields({
        fromDate: {
          value: fromDate,
        }
      });
    }

    let toDateErrors = [];
    if (!toDate) {
      toDateErrors.push(new Error('Please input end date!'));
    }
    if (toDate && fromDate && fromDate.isAfter(toDate)) {
      toDateErrors.push(new Error('End date cannot occur before start date!'));
    }
    if (toDateErrors.length > 0) {
      form.setFields({
        toDate: {
          value: toDate,
          errors: toDateErrors,
        }
      });
    } else {
      form.setFields({
        toDate: {
          value: toDate,
        }
      });
    }

    let selectedResourceErrors = [];
    if (_.isEmpty(selectedResource)) {
      selectedResourceErrors.push(new Error('Please select a resource'));
    }
    if (selectedResourceErrors.length > 0) {
      form.setFields({
        selectedResource: {
          value: selectedResource,
          errors: selectedResourceErrors,
        }
      });
    } else {
      form.setFields({
        selectedResource: {
          value: selectedResource,
        }
      });
    }
  }

  const returnSearchValues = () => {
    const { name, sso } = getFieldsValue();
    props.handleResourceSearch(name, sso);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    validateForm();
    const errors = {};
    // collect all fields currently in error state
    for (const [field, error] of Object.entries(getFieldsError())) {
      if (error) {
        errors[`${field}`] = error;
      }
    }
    if (Object.values(errors).length === 0) {
      let formValues = getFieldsValue();
      formValues.selectedResource = selectedResource;
      console.log('Success! Received values of form: ', formValues)
      props.searchByResource(formValues, by);
    } else {
      invalidForm();
      console.log('Invalid Form! ', errors);
    }
  }

  return (
    <Form
      onSubmit={(e) => handleSubmit(e)}>

      <Form.Item
        label="From Date"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('fromDate', {
          rules: [
            {
              required: true,
              message: 'Please input start date!'
            },
          ],
        })(
          <DatePicker
            name="fromDate"
            // showTime={{ format: datePickerFormat, use12Hours: true }}
            onChange={(e) => props.handleFromDateChange(e, validateForm)}
            allowClear={false}
            placeholder={'Select date and time'}
            format={datePickerFormat}
            size={'large'}
            styles={{
              popup: {
                root: {
                  zIndex: 2000
                }
              }
            }}
          />
        )}
      </Form.Item>

      <Form.Item
        label="To Date"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('toDate', {
          rules: [
            {
              required: true,
              message: 'Please input end date!'
            },
          ],
        })(
          <DatePicker
            name="toDate"
            // showTime={{ format: datePickerFormat, use12Hours: true }}
            onChange={(e) => props.handleToDateChange(e, validateForm)}
            allowClear={false}
            placeholder={'Select date and time'}
            format={datePickerFormat}
            size={'large'}
            styles={{
              popup: {
                root: {
                  zIndex: 2000
                }
              }
            }}
          />
        )}
      </Form.Item>

      {/* Resource Search */}
      <Form.Item
        label="Selected Resource"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('selectedResource', {
          initialValue: '',
          rules: [
            {
              required: true,
              message: 'Please select a resource!'
            },
          ],
        })(
          <Input
            type="text"
            name="selectedResource"
            placeholder={'No selected resource'}
            size={'large'}
            disabled
          ></Input>
        )}
      </Form.Item>

      <Form.Item
        label="Name"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('name', {
          initialValue: '',
        })(
          <Input
            type="text"
            name="name"
            placeholder={'Resource name'}
            size={'large'}
          ></Input>
        )}
      </Form.Item>

      <Form.Item
        label="SSO"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('sso', {
          initialValue: '',
        })(
          <Input
            type="text"
            name="sso"
            placeholder={'SSO'}
            size={'large'}
          ></Input>
        )}
      </Form.Item>

      <Form.Item style={{ marginBottom: 5 }}>
        <Button className="form-button" onClick={returnSearchValues}>
          Search
        </Button>
      </Form.Item>

      {resources && resources.length > 0 &&
        <React.Fragment>
          <Table
            columns={[
              {
                title: 'Resource name',
                dataIndex: 'name',
                render: text => <a>{text}</a>
              },
              {
                title: 'Cost Center Name',
                dataIndex: 'dName',
                render: text => <a>{text}</a>
              },
            ]}
            dataSource={resources}
            size="small"
            onRow={record => ({
              onClick: (e) => props.handleSelectResource(record)
            })}

          />
        </React.Fragment>
      }

      <Form.Item
        label="Filter"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('filter', {
          initialValue: filter[0].value || null,
          rules: [{
            required: true, message: 'Please input a status!',
          }],
        })(
          <Select
            name='filter'
            allowClear={false}
            style={{ width: 250 }}
            dropdownStyle={{ zIndex: 2000 }}
          >
            {filter.map((filterOption, index) => {
              return <Option key={'filterOption' + index} value={filterOption.value} >{filterOption.name}</Option>
            })}
          </Select>
        )}
      </Form.Item>

      <Form.Item
        style={{ marginBottom: 24 }}
      >
        {getFieldDecorator('sortByCostObject', {
          initialValue: false,
        })(
          <Checkbox name='sortByCostObject'>
            Sort By Cost Object
          </Checkbox>
        )}
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType='submit'>
          Search
        </Button>
      </Form.Item>

    </Form >
  );
}

export default ApprovalFindByResourceForm;
